import Marquee from "react-fast-marquee";

const WORDS = ["Facials", "Lash Artistry", "Skin Health", "Brows", "By Appointment", "Boronia"];

export const Ribbon = ({ bg = "#F8F6F0" }) => (
  <div className="border-y border-[#D5CFC1]/60 py-5 sm:py-7" style={{ backgroundColor: bg }} data-testid="ribbon">
    <Marquee speed={38} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="mx-8 sm:mx-12 inline-flex items-center gap-8 sm:gap-12">
          <span className="font-serif italic text-3xl sm:text-5xl text-[#7A766C] font-light">{w}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-[#C4BEAF]" />
        </span>
      ))}
    </Marquee>
  </div>
);
